import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../services/endpoint.config.service';
declare let $: any;
@Component({
  selector: 'app-scanner-settings',
  templateUrl: './scanner-settings.component.html',
  styleUrls: ['./scanner-settings.component.scss']
})
export class ScannerSettingsComponent implements OnInit {

  constructor(private configs: ConfigService) { }
  sss:any;

  ngOnInit() {
    this.sss = $("#dvamxscan").amxScanMngr('992ada1b68b34b618173a221393ba8ce',this.configs.getEnviromentId());
    this.sss.start();
    this.sss.result = function (e) {
		  var y = e;
	  };   
    
    setTimeout(() => {
      this.sss.config();
     }, 2000)
  }

}
